// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2kpVL","infoBtn":"quickbooks_infoBtn__3_eGO","formBox":"quickbooks_formBox__2Ao-9","formFooter":"quickbooks_formFooter__qj-ed"};